import React from 'react';

import Layout from 'src/app/components/Layout/Layout';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import RegulationsContact from 'src/app/components/RegulationsContact';
import ExperienceForm from 'src/app/containers/Registration/Experience/ExperienceFormContainer';
import background from 'src/assets/images/background-registration.jpg';
import 'src/app/containers/Registration/Experience/ExperienceComponent.scss';


const ExperienceComponent = () => (
  <Layout>
    <LayoutLeftColumn>

      <h4 styleName="experience-title">
        Poznajmy się
      </h4>

      <p styleName="experience-subtitle">
        Powiedz nam więcej o sobie, dzięki temu dopasujemy oferty do Twoich oczekiwań.
      </p>

      <ExperienceForm/>

      <RegulationsContact/>

    </LayoutLeftColumn>

    <LayoutRightColumn background={ background }>
      <h1 styleName="marketing-headline">Znajdź pracę skrojoną na miarę Twoich oczekiwań</h1>
    </LayoutRightColumn>

  </Layout>
);


export default ExperienceComponent;
